
























import Vue from "vue";
import "../styles.scss";
import AppMinBar from "../mini-bar/index.vue";
import { Lang } from "@/services/helper";
import { mapMutations } from "vuex";

const TopBanner = Vue.extend({
  name: "TopBanner",

  components: { AppMinBar },

  data() {
    return {
      isVisible: false,
    };
  },

  methods: {
    ...mapMutations({
      SET_APP_LOADING: "App/SET_APP_LOADING",
    }),

    async switchAppLang(): Promise<void> {
      await this.SET_APP_LOADING(true);

      await setTimeout(async () => {
        await Lang.switch();
        await window.location.reload();
      }, 200);
    },

    toggleMiniBar(): void {
      this.isVisible = !this.isVisible;
    },
  },
});
export default TopBanner;
